<template>
  <div>
    <div class="content" v-show="show">

      <div class="middleImg">
        <div class="vedioPosition left">
          <div><img style="width:346px" src="../../site/vedio.gif"></div>
          <div style="margin-top:30px; text-align:center"><img style="width:126px" src="../../site/loveIcon.png"></div>
        </div>
        <div class="right" style="width:500px">
          <div><img style="margin-top:90px; width:350px" src="../../site/ttqLogo1.png"></div>
          <div><img style="margin-top:90px; width:200px" src="../../site/slingUpdataErcode.png?1"></div>
          
        </div>
        <div style="clear:both"></div>
      </div>

      <div class="closeBtn" @click="show=false">关闭</div>

    </div>
  </div>
</template>

<script>
export default {
  name: "client",
  components: {
   
  },
  data() {
    return {
      show:false,
    };
  },
  methods: {
   
  },
  mounted() {
    
  }
};

</script>
<style scoped>
span{display: inline-block;}
.left{float: left;}
.right{float: right;}
.content{position: fixed; left:0; top:0; z-index: 999; width: 100%;height: 100%;background:transparent url(../../site/slingBck.jpg) no-repeat center;background-size: cover;}

.middleImg{margin: auto; margin-top: 160px; width: 1000px;}

.closeBtn{cursor: pointer; position: absolute; right:7%;top:7%;width: 100px;font-size: 16px; color: #fff; text-align: center; line-height: 48px; background:rgba(0, 0, 0, .28);border-radius: 25px;}
</style>



// WEBPACK FOOTER //
// client.vue?c2aff93a